import { formValueSelector } from 'redux-form';
import {
  getAdditionalCertHolders,
  startLoading,
  GET_ADDITIONAL_CERT_HOLDERS,
} from '../Actions/actions';
import { formName } from '../Constants/constants';
import Debounce from './Debounce';

let currentValue;
const formValues = formValueSelector(formName);
const debouncePeriod = 500;

function select(state) {
  return {
    isFederalEntity: state.formPage.venue.isFederalEntity ? 1 : 0,
    isKentuckyEntity: state.formPage.venue.isKentuckyEntity ? 1 : 0,
    venueMunicipalityCode: formValues(state, 'venueMunicipalityCode'),
    placeId: state.formPage.venue.selectedPlaceId,
    validManualAddress: state.formPage.venue.validManualAddress,
    override: state.formPage.venue.venueCodeReferralOverride,
    manualAddress: {
      companyName: state.formPage.venue.manualAddressComponents.companyName,
      address1: state.formPage.venue.manualAddressComponents.address1,
      city: state.formPage.venue.manualAddressComponents.city,
      state: state.formPage.venue.manualAddressComponents.state,
      zip: state.formPage.venue.manualAddressComponents.zip,
    },
  };
}

function getQueryParamsCode(state) {
  let code = '';
  if (state.formPage.venue.venueCode) {
    code = state.formPage.venue.venueCode;
  } else {
    code = state.formPage.referral.venueCode
      ? state.formPage.referral.venueCode
      : state.formPage.referral.facilityCode;
  }

  return code;
}

function handleChange({ store }) {
  const previousValue = currentValue;
  const state = store.getState();
  currentValue = select(state);
  if (JSON.stringify(previousValue) !== JSON.stringify(currentValue)) {
    const code = getQueryParamsCode(state);

    if (!currentValue.override) {
      store.dispatch(startLoading(GET_ADDITIONAL_CERT_HOLDERS));
      store.dispatch(getAdditionalCertHolders(code));
    }
  }
}

const UpdateCertificateHolders = (store) => {
  const debounce = new Debounce({ period: debouncePeriod });
  store.subscribe(() => {
    debounce.do(handleChange, { store });
  });
};

export default UpdateCertificateHolders;
